import React from 'react';
import { Row, Col, Space } from 'antd';
import TitleComponent from '../TitleComponent';

function TitleSection({ realmObject, accessDenied }) {
  const props = accessDenied
    ? { title: 'Access Denied', titleSize: 'large', titleEditable: false }
    : realmObject
    ? { title: realmObject.name || 'Unnamed', titleSize: 'large', titleEditable: true }
    : {};

  return (
    <Row justify="space-between" align="middle" className="element-margined-medium">
      <Col span={24}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <TitleComponent {...props} />
        </Space>
      </Col>
    </Row>
  );
}

export default TitleSection;
